// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__22erb","inputWrap":"Table_inputWrap__1kNZY","col":"Table_col__17Epf","bmiTooltip":"Table_bmiTooltip__1tXZY"};